export class SignInCancelledError extends Error {
  constructor() {
    super("Sign in cancelled");
    this.name = SignInCancelledError.name;
  }
}

export class PopupBlockedError extends Error {
  constructor() {
    super("Sign in popup blocked");
    this.name = PopupBlockedError.name;
  }
}

export class WrongCredentialsError extends Error {
  constructor() {
    super("Wrong email or password");
    this.name = WrongCredentialsError.name;
  }
}

export class CredentialAlreadyInUseError extends Error {
  constructor(readonly email?: string) {
    super(`${email ?? "Email"} already in use`);
    this.name = CredentialAlreadyInUseError.name;
  }
}

export class WeakPasswordError extends Error {
  constructor() {
    super("Password too weak");
    this.name = WeakPasswordError.name;
  }
}

export class InvalidEmailError extends Error {
  constructor() {
    super("Invalid email");
    this.name = InvalidEmailError.name;
  }
}

export class TooManyAttemptsError extends Error {
  constructor() {
    super("Too many sign in attempts");
    this.name = TooManyAttemptsError.name;
  }
}
